import { ROUTE_FITTER_SERVICE_NAME, RouteFitterServiceProvider } from './route.fitter.service'
import { ROUTE_OPERATORS_SERVICE_NAME, RouteOperatorServiceProvider } from './route.operator.service'
import { ROUTE_POINTS_SERVICE_NAME, RoutePointServiceProvider } from './route.points.service'
import { ROUTE_SERVICE_NAME, RouteServiceProvider } from './route.service'
import { ROUTE_TRACKING_SERVICE_NAME, RouteTrackingServiceProvider } from './route.tracking.service'

export const ROUTE_SERVICES_MODULE_NAME = 'simax.services.route'

const routeServicesModule = angular.module(ROUTE_SERVICES_MODULE_NAME, [])

routeServicesModule.provider(ROUTE_FITTER_SERVICE_NAME, RouteFitterServiceProvider)
routeServicesModule.provider(ROUTE_OPERATORS_SERVICE_NAME, RouteOperatorServiceProvider)
routeServicesModule.provider(ROUTE_POINTS_SERVICE_NAME, RoutePointServiceProvider)
routeServicesModule.provider(ROUTE_SERVICE_NAME, RouteServiceProvider)
routeServicesModule.provider(ROUTE_TRACKING_SERVICE_NAME, RouteTrackingServiceProvider)